import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DisplayService {

  private BODY_NO_SCROLL_CLASS = "no-scroll";
  private _elementsListeningVVResize: HTMLElement[] = [];
  private _elementsAllowedScrolling: HTMLElement[] = [];
  private MOBILE_BREAKPOINT_WIDTH = 992;

  private windowScrollListenerHandler = this.onWindowScroll.bind(this);
  private windowTouchMoveListenerHandler = this.onWindowTouchMove.bind(this);
  private elementTouchMoveListenerHandler = this.onElementTouchMove.bind(this);
  private windowResizeListener = new Subject<Event>();
  private savedScrollPosition = {x: 0, y: 0};
  private forceScrollTop = false;
  constructor() {
    window.visualViewport?.addEventListener("resize", ($event) => {
      // console.warn("RESIZE VISUAL VIEWPORT IN DISPLAY SERVICE");
      this.windowResizeListener.next($event);
      this.setElementsListeningVVResizeHeight();
    })
  }
  timeout = -1;

  setElementsListeningVVResizeHeight() {
    if(window.visualViewport) {
      const vv = window.visualViewport;
      window.document.body.style.height = vv.height + "px";
      this._elementsListeningVVResize.forEach((el) => {
        el.style.height = vv.height + "px";
      })
    }
  }

  onWindowScroll($event: Event) {
    $event.preventDefault();
    // console.log("SCROLL")
    this.scrollToSavedPosition();
  }

  onElementTouchMove($event: Event) {
    // console.log("STOP PROPAGATION");
    $event.stopPropagation();
    this.scrollToSavedPosition();
  }

  private scrollToSavedPosition() {
    let shouldScroll = true;

    if(window.visualViewport) { // it prevents scroll to saved position if keyboard on mobile opened
      if(window.visualViewport.height < window.innerHeight && false) {
        shouldScroll = false;
      }
    }

    if(shouldScroll) {
      if(this.forceScrollTop) {
        window.scrollTo(0, 0);
        // console.log("Scroll to top");

      } else {
        window.scrollTo(this.savedScrollPosition.x,this.savedScrollPosition.y);
        // console.log("Scroll To", this.savedScrollPosition.x, this.savedScrollPosition.y);
      }
    }

  }
  onWindowTouchMove($event: Event) {
    // console.log("PREVENTING");

    const targetHtmlEl = $event.target as HTMLElement;
    for(let i  = 0; i < this._elementsAllowedScrolling.length; i++) {
      if(this._elementsAllowedScrolling[i] === targetHtmlEl || this._elementsAllowedScrolling[i].contains(targetHtmlEl)) {
        $event.preventDefault();
        window.scrollTo(0,0);
        break;
      }
    }
  }

  onWindowResize(): Observable<Event> {
    return this.windowResizeListener;
  }

  disableBodyScroll(allowedElements: HTMLElement[] = [], forceScrollTop: boolean = false): void {
    // console.warn("DISABLING BODY SCROLL");
    // console.log(window.scrollX, window.scrollY);
    this.savedScrollPosition = {x: window.scrollX, y: window.scrollY};
    window.document.body.classList.add(this.BODY_NO_SCROLL_CLASS);
    window.document.addEventListener("scroll", this.windowScrollListenerHandler, {passive: false});
    window.document.addEventListener("touchmove", this.windowTouchMoveListenerHandler, {passive: false})
    this._elementsAllowedScrolling = allowedElements;

    allowedElements.forEach((el) => {
      el.addEventListener("touchmove", this.elementTouchMoveListenerHandler, {passive: false});
    });

    this.forceScrollTop = forceScrollTop;

    // window.document.querySelector(".searchbar")?.addEventListener("touchmove", ($event) => {
    //   console.log("STOP PROPAGATION");
    //   $event.stopPropagation();
    //   window.scrollTo(0,0);
    // })
    //
    // window.document.querySelector(".overlay-window__content")?.addEventListener("touchmove", ($event) => {
    //   console.log("STOP PROPAGATION");
    //   $event.stopPropagation();
    //   window.scrollTo(0,0);
    // })

  }

  enableBodyScroll(): void {
    // console.warn("ENABLING BODY SCROLL");
    window.document.body.classList.remove(this.BODY_NO_SCROLL_CLASS);

    window.document.removeEventListener("scroll", this.windowScrollListenerHandler);

    window.document.removeEventListener("touchmove", this.windowTouchMoveListenerHandler)

    this._elementsAllowedScrolling.forEach((el) => {
      el.removeEventListener("touchmove", this.elementTouchMoveListenerHandler);
    })
    this._elementsAllowedScrolling = [];

    if(this.forceScrollTop) {
      window.scrollTo(this.savedScrollPosition.x, this.savedScrollPosition.y);

      this.forceScrollTop = false;
    }
  }

  addElementFillVVHeight(el: HTMLElement) {
    this._elementsListeningVVResize.push(el);
    this.setElementsListeningVVResizeHeight();
  }

  removeElementFillVVHeight(el: HTMLElement) {
    this._elementsListeningVVResize = this._elementsListeningVVResize.filter((localEl) => localEl !== el);
    el.style.height = "";
  }

  isMobileScreenSize(): boolean {
    if(window.visualViewport) {
      return window.visualViewport.width < this.MOBILE_BREAKPOINT_WIDTH;
    }

    return window.innerWidth < this.MOBILE_BREAKPOINT_WIDTH;
  }


}
